import { SupportedLanguage } from "../types/SupportedLanguage";

export const TOP_BAR_HEIGHT: number = 64;

export const SIDE_NAVIGATION_WIDTH: number = 260;

export const NAVIGATION_BAR_HEIGHT: number = 60;

export const SIDE_NAVIGATION_COMPACT_WIDTH: number = 80;

export const CONTAINED_LAYOUT_WIDTH: number = 1200;

export const BREAKPOINTS: number[] = [3840, 1920, 1080, 640, 384, 256, 128];

export const ORGANIZING_AND_SUPPORTING_INSTITUTIONS_SLIDE_IMAGE_WIDTH: number = 500;

export const ORGANIZING_AND_SUPPORTING_INSTITUTIONS_SLIDE_IMAGE_HEIGHT: number = 500;

export const VENUE_WITH_GALLERY_SLIDE_IMAGE_WIDTH: number = 1200;

export const VENUE_WITH_GALLERY_SLIDE_IMAGE_HEIGHT: number = 800;

export const EVENT_GALLERY_SLIDE_IMAGE_WIDTH: number = 1200;

export const EVENT_GALLERY_SLIDE_IMAGE_HEIGHT: number = 800;

export const CONFERENCE_APPLICATION_TYPE_WITH_REPORT: string = "WithReport";

export const CONFERENCE_APPLICATION_TYPE_AS_LISTENER: string = "AsListener";

export const CONFERENCE_APPLICATION_TYPE_SPECIAL_SESSION: string = "SpecialSession";

export const PDF_EXTENSION: string = ".pdf";

export const TEX_EXTENSION: string = ".tex";

export const LTX_EXTENSION: string = ".ltx";

export const STY_EXTENSION: string = ".sty";

export const CLS_EXTENSION: string = ".cls";

export const DOCX_EXTENSION: string = ".docx";

export const DOC_EXTENSION: string = ".doc";

export const scientificFieldForLanguageTranslationsNDMI = {
  bg: {
    "Mathematical analysis, Geometry and Applications": "Математически анализ, геометрия и приложения",
    "Discrete Structures": "Дискретни структури",
    "Computer Science": "Информатика и информационни технологии",
    "Education in Mathematics and Informatics": "Обучението по математика и информатика",
  },
  en: {
    "Математически анализ, геометрия и приложения": "Mathematical analysis, Geometry and Applications",
    "Дискретни структури": "Discrete Structures",
    "Информатика и информационни технологии": "Computer Science",
    "Обучението по математика и информатика": "Education in Mathematics and Informatics",
  },
} as const;

export const scientificFieldForLanguageTranslationsThirtyFiveYearsFMI = {
  bg: {
    "Mathematical and Applied Sciences": "Математика и приложения",
    "Information and Communication Technologies": "Информационни и комуникационни технологии",
    "Education in Mathematics and Informatics": "Обучение по математика и информатика"
  },
  en: {
    "Математика и приложения": "Mathematical and Applied Sciences",
    "Информационни и комуникационни технологии": "Information and Communication Technologies",
    "Обучение по математика и информатика": "Education in Mathematics and Informatics"
  }
}

export const applicationTypesForLanguageTranslations = {
  bg: {
    WithReport: "С доклад в направление",
    SpecialSession: "С доклад в специална сесия",
    AsListener: "Без доклад, като слушател",
  },
  en: {
    WithReport: "With Talk in a scientific field",
    SpecialSession: "With Talk in a special session",
    AsListener: "Without Talk, as a listener",
  },
} as const;

export type ScientificFieldsTranslationMap = Record<SupportedLanguage, Record<string, string>>;

export type ScientificFieldTranslationKey = keyof ScientificFieldsTranslationMap[SupportedLanguage];

export type ApplicationTypesTranslations = typeof applicationTypesForLanguageTranslations;

export type ApplicationTypeTranslationKey = keyof ApplicationTypesTranslations[SupportedLanguage];

export const CREATE_OR_EDIT_SPECIAL_SESSION_REQUIRED_FIELD_ERROR_MESSAGE: string = "Задължително поле";

export const CREATE_OR_EDIT_SPECIAL_SESSION_INVALID_EMAIL_ERROR_MESSAGE: string = "Невалиден имейл";

export const CREATE_OR_EDIT_SPECIAL_SESSION_REQUIRED_AT_LEAST_THREE_SPEAKERS_ERROR_MESSAGE: string = "Трябва да бъдат въведени имената на поне трима докладчици";

export const CREATE_OR_EDIT_SPECIAL_SESSION_REQUIRED_AT_MOST_SEVEN_SPEAKERS_ERROR_MESSAGE: string = "Трябва да бъдат въведени имената на най-много седем докладчици";

export const CREATE_OR_EDIT_SPECIAL_SESSION_NAME_BG_MAX_LENGTH_ERROR_MESSAGE: string = "Максимален брой символи за име на специална сесия бълг.";

export const CREATE_OR_EDIT_SPECIAL_SESSION_NAME_EN_MAX_LENGTH_ERROR_MESSAGE: string = "Максимален брой символи за име на специална сесия англ.";

export const CREATE_OR_EDIT_SPECIAL_SESSION_ORGANIZER_NAME_BG_MAX_LENGTH_ERROR_MESSAGE: string = "Максимален брой символи за име на организатор бълг.";

export const CREATE_OR_EDIT_SPECIAL_SESSION_ORGANIZER_NAME_EN_MAX_LENGTH_ERROR_MESSAGE: string = "Максимален брой символи за име на организатор англ.";

export const CREATE_OR_EDIT_SPECIAL_SESSION_ORGANIZER_INSTITUTION_BG_MAX_LENGTH_ERROR_MESSAGE: string = "Максимален брой символи за институтиця на организатор бълг.";

export const CREATE_OR_EDIT_SPECIAL_SESSION_ORGANIZER_INSTITUTION_EN_MAX_LENGTH_ERROR_MESSAGE: string = "Максимален брой символи за институция на организатор англ.";

export const CREATE_OR_EDIT_SPECIAL_SESSION_ORGANIZER_EMAIL_MAX_LENGTH_ERROR_MESSAGE: string = "Максимален брой символи за имейл на организатор";

export const CREATE_OR_EDIT_SPECIAL_SESSION_SHORT_DESCRIPTION_BG_MAX_LENGTH_ERROR_MESSAGE: string = "Максимален брой символи за кратко описание бълг.";

export const CREATE_OR_EDIT_SPECIAL_SESSION_SHORT_DESCRIPTION_EN_MAX_LENGTH_ERROR_MESSAGE: string = "Максимален брой символи за кратко описание англ.";

export const PROGRAM_SECTION_DAY_ENTRY_CONFERENCE_TALKS_BG: string = "ДОКЛАДИ";

export const PROGRAM_SECTION_DAY_ENTRY_CONFERENCE_TALKS_EN: string = "CONFERENCE TALKS";

export const PROGRAM_SECTION_DAY_ENTRY_COFFEE_BREAK_BG: string = "Кафе пауза";

export const PROGRAM_SECTION_DAY_ENTRY_COFFEE_BREAK_EN: string = "Coffee break";

export const PROGRAM_SECTION_DAY_ENTRY_LUNCH_BREAK_BG: string = "Обедна почивка";

export const PROGRAM_SECTION_DAY_ENTRY_LUNCH_BREAK_EN: string = "Break";

export const PROGRAM_SECTION_DAY_ENTRY_SESSION_KEYWORD_BG: string = "Секция";

export const PROGRAM_SECTION_DAY_ENTRY_SESSION_KEYWORD_EN: string = "Session";

export const PROGRAM_SECTION_DAY_ENTRY_OFFICIAL_DINNER_BG: string = "Официална вечеря";

export const PROGRAM_SECTION_DAY_ENTRY_OFFICIAL_DINNER_EN: string = "Official dinner";

export const PROGRAM_SECTION_DAY_ENTRY_SPECIAL_SESSION_KEYWORD_BG: string = "Специална сесия";

export const PROGRAM_SECTION_DAY_ENTRY_SPECIAL_SESSION_KEYWORD_EN: string = "Special Session";

export const PROGRAM_SECTION_DAY_ENTRY_CONFERENCE_CLOSING_BG: string = "Закриване на конференцията";

export const PROGRAM_SECTION_DAY_ENTRY_CONFERENCE_CLOSING_EN: string = "Closing the conference";

export const PROGRAM_SECTION_DAY_ENTRY_PUBLIC_LECTURES_IN_BULGARIAN_EN: string = "Public Lectures (in Bulgarian)";

export const AN_ERROR_OCCURRED_MESSAGE: string = "Възникна грешка";